import { Controller } from "@hotwired/stimulus";

// 120ms number roll in the direction of travel. Rapid presses cancel the
// in-flight animation and snap to the newest value (design motion spec).
export default class extends Controller {
  static targets = ["value", "input", "decrement"];
  static values = { min: Number, count: Number };

  disconnect() {
    clearTimeout(this.cleanup);
  }

  countValueChanged() {
    this.inputTarget.value = this.countValue;
    if (this.hasDecrementTarget) {
      this.decrementTarget.disabled = this.countValue <= this.minValue;
    }
  }

  increment() {
    this.roll(this.countValue + 1, "roll-up");
  }

  decrement() {
    if (this.countValue <= this.minValue) return;
    this.roll(this.countValue - 1, "roll-down");
  }

  roll(next, direction) {
    this.countValue = next;
    const el = this.valueTarget;
    el.classList.remove("roll-up", "roll-down");
    void el.offsetWidth; // cancel in-flight animation, snap to newest
    el.textContent = next;
    el.classList.add(direction);
    clearTimeout(this.cleanup);
    this.cleanup = setTimeout(() => el.classList.remove("roll-up", "roll-down"), 140);
  }
}
